import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonReviseProduct(props) {
    const map = useMapContext()

    if (! (
        map.permission.has('revise') &&
        'RLS' === map.dp.stsCode
    )) {
        return null
    }

    return (
        <MenuButton
            onClick={() => map.revise()}
            {...props}
        >
            修订
        </MenuButton>
    )
}
